import { PartSalesDetail } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface PartSalesDetailsState extends EntityState<PartSalesDetail> {}

export const partSalesDetailsAdapter: EntityAdapter<PartSalesDetail> = createEntityAdapter<PartSalesDetail>({
  selectId: (partSalesDetail: PartSalesDetail) => partSalesDetail.id
});
export const initialPartSalesDetailsState: PartSalesDetailsState = partSalesDetailsAdapter.getInitialState({});
